module.exports = __webpack_public_path__ + "img/gallery-frame03.42943781.png";